export enum CardContentTypeEnum {
  ADD = "add",
  REMOVE = "remove",
}
